<template>
  <div class="content">
    <el-page-header @back="goBack" class="pageHeader" :content="`${$store.state.themeTitle}室设备管理`">
    </el-page-header>
    <div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="采购信息" name="first">
          <PurchaseInfo ref="purchaseInfo" :query="query" />
        </el-tab-pane>
        <el-tab-pane label="入库信息" name="second">
          <Warehousinfo ref="warehousinfo" :query="query" />
        </el-tab-pane>
        <el-tab-pane label="使用信息" name="third">
          <UseInfo ref="userInfo" :query="query" />
        </el-tab-pane>
        <el-tab-pane label="维修记录" name="fourth">
          <FixRecord ref="fixRecord" :query="query" />
        </el-tab-pane>
        <el-tab-pane label="预约记录" name="fifth">
          <AppointmentRecord ref="appointmentRecord"  :query="query" />
        </el-tab-pane>
      </el-tabs>
    </div>
    <div>

    </div>
  </div>
</template>

<script>
import PageLine from '@/components/page';
import PurchaseInfo from './components/purchaseInfo';
import Warehousinfo from './components/warehousinfo';
import UseInfo from './components/useInfo';
import FixRecord from './components/fixRecord';
import AppointmentRecord from './components/appointmentRecord';

export default {
  name: 'trainingRoom',
  data() {
    return {
      formInline: {
        user: '',
        region: '',
        date: '',
      },
      centerDialogVisible: false,
      total: 40,
      activeName: 'first',
      tableData: [],
      query:''
    };
  },
  components: {
    PageLine,
    PurchaseInfo,
    Warehousinfo,
    UseInfo,
    FixRecord,
    AppointmentRecord,
  },
  created() {
    this.query = this.$route.query
  },
  mounted() {
    // this.getStudentApply()
    // this.getProvince()
    this.handleClick({name:this.activeName})
  },
  methods: {
    goBack() {
      // history.back();
      this.$router.push({
        path: '/changeTrains',
        query:{
          path: "trainingRoom",
        }
      });
    },
    onSubmit() {
      console.log('submit!');
    },
    handleClick(tab, event){
      switch(tab.name){
        case 'first':
          this.$refs.purchaseInfo.getList();
          break;
        case 'second':
          this.$refs.warehousinfo.getList();
          break;
        case 'third':
          this.$refs.userInfo.getList();
          break;
        case 'fourth':
          this.$refs.fixRecord.getList();
          break;
        case 'fifth':
          this.$refs.appointmentRecord.getList();
          break;
        default:
          this.$refs.purchaseInfo.getList();
          break;
      }
    },
    getList() {},
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: 282px;
}
</style>
